module.exports = __webpack_public_path__ + "assets/img/teacher (6).ee461ecb.png";